import { sortTeams } from './../utils/teamUtils';
import { Team } from './../types/core';
import { companyFieldState } from './accountState';
import { selector, selectorFamily } from './recoilSelectors';


export const teamsState = selector({
    key: 'teams.all',
    get: ({ get }) => {
        const teamsConfig = get(companyFieldState("teams_config")) ?? [];
        return [...teamsConfig].sort(sortTeams);
    }
});

export const teamState = selectorFamily<Team | undefined, number>({
    key: 'team',
    get: (id) => ({ get }) => {
        const teams = get(teamsState);
        const team = teams.find((team) => team.id === id);
        return team;
    }
});